export class VerticalNotLaunchedError extends Error {}
